import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import { ColorPickerPopover } from "./ColorPickerPopover.js";
import { ColorPickerRouter } from "./ColorPickerRouter.js";
import { Tabs } from "./Tabs.js";
function ColorPickerBody(props) {
  const { trigger, testId = "ColorPicker" } = props;
  if (trigger) {
    return /* @__PURE__ */ jsx(ColorPickerPopover, { testId, ...trigger, children: /* @__PURE__ */ jsx(ColorPickerContent, { ...props, testId: `${testId}--Content` }) });
  }
  return /* @__PURE__ */ jsx(ColorPickerContent, { ...props });
}
function ColorPickerContent(props) {
  const { testId = "ColorPicker", ...otherProps } = props;
  return /* @__PURE__ */ jsx(Box, { "data-testid": testId, p: 2, children: /* @__PURE__ */ jsxs(Stack, { gap: 2, width: "100%", children: [
    /* @__PURE__ */ jsx(Tabs, { ...otherProps }),
    /* @__PURE__ */ jsx(ColorPickerRouter, { ...otherProps })
  ] }) });
}
export {
  ColorPickerBody
};
//# sourceMappingURL=ColorPickerBody.js.map
